export default {
  title: `Letter of Authority tracking`,
  // The system never contacts the provider. The adviser issues the LOA exactly
  // as they do today; this panel only records the lifecycle for the case file.
  tooltip: `Track each Letter of Authority you issue to a provider: record when it was sent, chase it, and log the response. The system never contacts the provider — you send the LOA as you do today, this only records the lifecycle.`,
  // Rendered on the panel itself (not just the tooltip) after the 2026-07
  // client review: advisers must see where the letter's data comes from and
  // that nothing is transmitted automatically, without hovering anything.
  sourceNote: `The letter is generated from the fact find (selected asset and personal details) and your practice settings. Nothing is sent to the provider automatically — the actions below only record the lifecycle for the case file.`,
  empty: `No letters of authority are being tracked for this case yet.`,
  statuses: {
    draft: `Draft`,
    issued: `Issued`,
    chased: `Chased`,
    responded: `Responded`,
    further_information_required: `Further information required`,
    closed: `Closed`,
  },
  actions: {
    chase: `Chase`,
    record_response: `Record response`,
    require_further_information: `Further information required`,
    close: `Close`,
  },
  // Filed copies of the issued pair (also in the case's Document Pack and the
  // client's vault); the link title carries the full filed name with the date.
  documents: {
    letter: `Letter of authority (PDF)`,
    informationRequest: `Information request (PDF)`,
  },
};
